import { InputHTMLAttributes, forwardRef } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';

type Props = {
  label?: string;
  isLabelNoneStyle?: boolean;
} & Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'classNames' | 'style' | 'type'
>;

const CheckBox = forwardRef<HTMLInputElement, Props>(
  ({ label, isLabelNoneStyle, ...props }, ref) => {
    const checkboxClassNames = classNames(
      isLabelNoneStyle && styles.checkboxNoLabel,
      styles.checkbox
    );
    return (
      <label
        className={classNames(
          isLabelNoneStyle && styles.containerNoLabel,
          styles.container
        )}
      >
        <input
          {...props}
          className={checkboxClassNames}
          type="checkbox"
          ref={ref}
        />
        <span className={styles.label}>{label}</span>
      </label>
    );
  }
);
CheckBox.displayName = 'CheckBox';

export default CheckBox;
